import { getInstance } from "./auth/authWrapper";
import config from "./config";
const authService = getInstance();

const nav = {
  menu:[],
  init() {
    const role = new String(authService.userRole).toUpperCase();
    this.menu = this.menu.concat(this.getReportMenu(role));
    this.menu = this.menu.concat(this.getConfigurationMenu(role));
    if(role != 'SALESPERSON' || config.partnersConfiguration.payments.salesPerson) {
      this.menu = this.menu.concat(this.getFinanceMenu(role));
    }    
    this.menu = this.menu.concat(this.getPlatformMenu(role));
    if(role == 'SELLER' && (config.partnersConfiguration.key == 'SEPAG' || config.partnersConfiguration.key == 'QUADRIPAY')) {
      let items = [{ title: true, name: 'Central de Ajuda', class: '', wrapper: { element: '', attributes: {} } },
        { name: 'Financeiro', url: 'https://api.whatsapp.com/send/?phone=5541985332894', icon: 'cui-user', attributes: {target: '_blank'}},
        { name: 'Suporte', url: 'https://api.whatsapp.com/send/?phone=5541984286038', icon: 'cui-user', attributes: {target: '_blank'}}
      ];
      this.menu = this.menu.concat(items);
    }
  },
  getReportMenu(role) {
    let items = [{ title: true, name: 'Relatórios', class: '', wrapper: { element: '', attributes: {} } },
    {
      name: 'Extratos', icon: 'icon-speedometer',
      children: []
    }];

    let transactionsItems = { name: 'Transações', url: '/reports/transactions', icon: 'cui-file' };
    let detailedTransactionItems = { name: 'Transações Detalhe', url: '/reports/detailedtransactions', icon: 'cui-file' };
    let receivableTransactionsItems = { name: 'Agenda futura', url: '/reports/receivabletransactions', icon: 'cui-file' };
    let statementItems = { name: 'Financeiro', url: '/reports/statement', icon: 'icon-credit-card' };
    let deviceRentalChargeItem = { name: 'Aluguel Terminais', url: '/reports/devicerentalcharges', icon: 'icon-screen-smartphone' };
    switch(role) {
      case "PARTNER":
      case "FINANCE":
        items[1].children.push(transactionsItems);
        if(config.partnersConfiguration.reports.detailedTransactions) {      
          items[1].children.push(detailedTransactionItems);
        }
        if(config.partnersConfiguration.reports.receivableTransactions) {  
          items[1].children.push(receivableTransactionsItems);            
        }
        if(config.partnersConfiguration.reports.statement) {
          items[1].children.push(statementItems);
        }
        if(config.partnersConfiguration.devices.rentalCharge.enabled) {
          items[1].children.push(deviceRentalChargeItem);
        }
        return items;
      case "BACKOFFICE":
        items[1].children.push(transactionsItems);
        return items;
      case "SELLER":
        items[1].children.push(transactionsItems);
        if(config.partnersConfiguration.sellers.statement) {
          items[1].children.push(statementItems);
        }
        if(config.partnersConfiguration.devices.rentalCharge.enabled) {
          items[1].children.push(deviceRentalChargeItem);
        }
        return items;
      case "SALESPERSON":
        items[1].children.push(transactionsItems);
        if(config.partnersConfiguration.reports.statement) {
          items[1].children.push(statementItems);
        }
        return items;
      case "LOGISTIC":
        items[1].children.push(transactionsItems);
        return items;
    }

    // if(role == 'PARTNER' || role == 'FINANCE') {      
    //   if(config.partnersConfiguration.reports.detailedTransactions) {      
    //     items[1].children.push({ name: 'Transações Detalhe', url: '/reports/detailedtransactions', icon: 'cui-file' });
    //   }
    //   if(config.partnersConfiguration.reports.receivableTransactions) {  
    //     items[1].children.push({ name: 'Agenda futura', url: '/reports/receivabletransactions', icon: 'cui-file' });            
    //   }
    // }

    // if(role != 'BACKOFFICE' && config.partnersConfiguration.reports.statement) {
    //   items[1].children.push({ name: 'Financeiro', url: '/reports/statement', icon: 'icon-credit-card' });
    // }
    // return items;
  },
  getConfigurationMenu(role) {
    let items = [{ title: true,  name: 'Configurações', class: '', wrapper: { element: '', attributes: {} }}];
    let sellerItem = { name: 'Empresas', url: '/partners', icon: 'icon-note',
      children: [
        { name: 'Cadastro', url: '/partners/sellers', icon: 'icon-star' },
        { name: 'Usuarios', url: '/partners/users', icon: 'icon-user' },        
      ]
    };
    let contractItem = { name: 'Contratos', url: '/partners/contracts', icon: 'cui-file' };
    let salesPersonItem = { name: 'Representantes', url: '/partners/salespeople', icon: 'icon-people' };    
    let deviceItems = config.partnersConfiguration.devices.usage.enabled ? { name: 'Terminais POS', url: '/partners/devices', icon: 'icon-screen-smartphone'
      ,children: [
        {name: 'Cadastro', url: '/partners/devices', icon: 'icon-star'},
        {name: 'Utilização', url: '/partners/devices/usage', icon: 'cui-file'},
      ] } : { name: 'Terminais POS', url: '/partners/devices', icon: 'icon-screen-smartphone'};

    let paymentLinkItem = { name: 'Links de pagamento', url: '/partners/paymentLinks', icon: 'cui-basket-loaded' }
    switch(role) {
      case "PARTNER":
      case "BACKOFFICE":
        items.push(sellerItem);
        items.push(contractItem);
        items.push(salesPersonItem);
        items.push(deviceItems);
        if(role == "PARTNER") {
          items.push(paymentLinkItem);
        }        
        return items;
      case "SELLER":
        if(!config.partnersConfiguration.sellers.paymentLink)
        {
          return [];
        }
        items.push(paymentLinkItem);
        return items;
      case "SALESPERSON":        
        sellerItem.children = sellerItem.children.splice(0, 1);
        items.push(sellerItem);        
        return items;
      case "FINANCE":
        items.push(contractItem);
        return items;
      case "LOGISTIC":
        items.push(deviceItems);
        return items;
    }    
  },
  getFinanceMenu(role) {
    let items = [{ title: true, name: 'Financeiro', class: '', wrapper: { element: '', attributes: {} } }];

    let withdrawItems = { name: 'Pagtos. / Saques', url: '/partners/payments', icon: 'cui-calculator'};
    let paymentGroupitems = { name: 'Remessas', url: '/partners/paymentgroups', icon: 'cui-calculator'};
    let addCashItems = { name: 'Adicionar Dinheiro', url: '/partners/cashtransactions', icon: 'cui-dollar' };
    let paymentProviderItem = { name: 'Transfeera', url: '/partners/paymentproviders', icon: 'cui-dollar' };
    switch(role) {
      case "PARTNER":
      case "FINANCE":  
        items.push(withdrawItems);
        if(config.partnersConfiguration.payments.paymentGroup.enabled) {
          items.push(paymentGroupitems);
        }
        if(config.partnersConfiguration.transactions.addCash) {
          items.push(addCashItems);
        }
        items.push(paymentProviderItem);
        return items;
      case "BACKOFFICE":
        items.push(withdrawItems);
        return items;
      case "SELLER":
        items.push(withdrawItems);
        return items;
      case "SALESPERSON":
        items.push(withdrawItems);
        return items;
      case "LOGISTIC":
        return [];
    }    
  },
  getPlatformMenu(role) {
    return role == 'PARTNER' || role == 'BACKOFFICE' ? [
      { title: true, name: 'Administração', class: '', wrapper: { element: '', attributes: {} } },
      { name: 'Plataforma', url: '/platform/acquirers', icon: 'icon-layers', children: [
        { name: 'Administradores', url: '/platform/users', icon: 'icon-user-follow' },
        /*{ name: 'Adquirentes', url: '/platform/acquirers', icon: 'icon-credit-card' },
        { name: 'Terminais POS', url: '/platform/deviceModel', icon: 'icon-screen-smartphone' },
        { name: 'Bancos', url: '/platform/banks', icon: 'icon-graph' }*/
      ]
    }] : [];
  }  
}
nav.init();
export {nav as default};